<template>
  <div class="container">
    <main-title />
    <div class="card">
      <page-title back :text="title"></page-title>
      <div class="viewer">
        <div class="medias">
         <!-- <div class="title video" v-if="ruleForm.work_type == 1">视频</div>
          <div class="video_box" v-if="ruleForm.work_type == 1">
            <video :src="fullVideo" controls></video>
          </div> -->
          <!-- <div class="title picture">照片</div>
          <img :src="p" alt="" v-for="(p, index) in fullPic" :key="index" /> -->
          <template v-if="ruleForm.attach_url">
            <div class="title word">诗稿文件</div>
            <a :href="fullAttach" download>{{ ruleForm.attach_url }}</a>
            <a :href="fullAttach" class="downIcon">下载</a>
          </template>
        </div>
        <div class="infos">
          <dl>
            <dt>作品名称</dt>
            <dd>{{ ruleForm.work_title }}</dd>
            <template v-for="(a, index) in ruleForm.authors">
              <div :key="index">
                <dt>
                  {{
                    ruleForm.work_type == 1 ? `朗诵者` + (index>0?(index + 1):'') : "作者"
                  }}
                </dt>
                <dd>
                  {{ a.name }}
				   <!-- {{ a.name + " （" + (a.sex == 1 ? "男" : "女") + "）" }} -->
                </dd>
              </div>
            </template>
			<dt>组别</dt>
            <dd>{{ ruleForm.group_name}}</dd>
            <dt>年级</dt>
            <dd>{{ showGrade(ruleForm.grade) }}</dd>
            <dt>指导老师</dt>
            <dd>{{ ruleForm.teacher }}</dd>
           <!-- <dt>联系电话</dt>
            <dd>{{ ruleForm.teacher_phone }}</dd> -->
          </dl>
          <el-button type="primary" plain @click="toDelete">删除 </el-button>
          <el-button type="primary" @click="toEdit">编辑 </el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { authFile, viewWork, deleteWork } from "@/api/work.js";
import { MessageBox } from "element-ui";
export default {
  name: "viewWork",
  data() {
    return {
		title:'返回',
      gradeList: [
        { id: 1, name: "一年级" },
        { id: 2, name: "二年级" },
        { id: 3, name: "三年级" },
        { id: 4, name: "四年级" },
        { id: 5, name: "五年级" },
        { id: 6, name: "六年级" },
        { id: 7, name: "七年级" },
        { id: 8, name: "八年级" },
        { id: 9, name: "九年级" },
		{ id: 10, name: "高一" },
		{ id: 11, name: "高二" },
		{ id: 12, name: "高三" },
      ],
      ruleForm: {},
      fullAttach: "",
      fullVideo: "",
      fullPic: [],
    };
  },
  watch: {},
  components: {},
  created() {
    let id = this.$route.query.id;
    this.viewWork(id);
  },
  methods: {
    async authFile(file) {
      let d = await authFile({ key: file });
      return d.data;
    },
    showGrade(g) {
      var typeValue = this.gradeList.filter((d) => d.id == g);
      return typeValue ? (typeValue.length > 0 ? typeValue[0].name : "") : "";
    },
    viewWork(id) {
      viewWork({ id }).then((d) => {
        this.ruleForm = d.data;
        this.ruleForm.video_url &&
          this.authFile(this.ruleForm.video_url).then((r) => {
            this.fullVideo = r;
          });
        this.ruleForm.attach_url &&
          this.authFile(this.ruleForm.attach_url).then((r) => {
            this.fullAttach = r;
          });
        if (this.ruleForm.pic_url) {
          let pics = this.ruleForm.pic_url.split(",");
          pics.forEach((p) => {
            this.authFile(p).then((r) => {
              this.fullPic.push(r);
            });
          });
        }
      });
    },
    toEdit() {
      this.$router.push({ path: "/add", query: { id: this.ruleForm.id } });
    },
    toDelete() {
      MessageBox.confirm(
        "确认删除" + this.ruleForm.work_title + "吗？",
        "删除作品",
        {
          confirmButtonText: "确认删除",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          deleteWork({ id: this.ruleForm.id }).then((d) => {
            this.$message.success("删除成功");
            this.$router.push("/main");
          });
        })
        .catch((c) => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.viewer {
  display: flex;
  padding: 10px 60px 70px;
  background-color: #fff;
  &:after {
    content: "";
    display: block;
    clear: both;
  }
  .medias {
    width: 55%;
    .title {
      margin: 30px 0 15px 0;
      padding-left: 24px;
      font-size: 18px;
      background: no-repeat left center;
      font-weight: 700;
      &.video {
        background-image: url("../../assets/icon_video.png");
      }
      &.picture {
        background-image: url("../../assets/icon_picture.png");
      }
      &.word {
        background-image: url("../../assets/icon_word.png");
      }
    }
    .video_box {
      position: relative;
      width: 100%;
      height: 360px;
      background-color: #000;
      video {
        position: absolute;
        width: 100%;
        height: 100%;
      }
    }
    img {
      max-width: 100%;
      max-height: 820px;
      margin-bottom: 20px;
      border-radius: 4px;
      &:first-child {
        margin-bottom: 0;
      }
    }
    a {
      color: #999999;
      font-size: 16px;
      &:hover {
        color: #bf3d36;
      }
      &:active {
        color: #999999;
      }
    }
    .downIcon {
      margin-left: 20px;
      padding-left: 20px;
      color: #bf3d36;
      background: url("../../assets/icon_download.png") no-repeat left center;
    }
  }
  .infos {
    padding-top: 40px;
    padding-left: 90px;
    width: 45%;
    dt {
      line-height: 46px;
      float: left;
      width: 120px;
    }
    dd {
      padding-top: 11px;
      min-height: 46px;
      line-height: 24px;
      overflow: hidden;
      font-weight: 700;
    }
  }
}
</style>
